var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "139px",
    height: "139px",
    viewBox: "0 0 139 139",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-XS-Max",
    transform: "translate(-131.000000, -270.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(132.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    cx: 68.5,
    cy: 68.5,
    r: 68.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F5A623",
    cx: 19,
    cy: 22,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C00808",
    cx: 123,
    cy: 27,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#417505",
    cx: 129,
    cy: 102,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#9013FE",
    cx: 103,
    cy: 128,
    r: 9
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c3409efc8e12c28930ee9f38c88ff5d6.svg";
export { ForwardRef as ReactComponent };